var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"helpContainer"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('help.title')))]),_vm._l((_vm.topLevelQuestions),function(question,index){return _c('collapsible-help-question',{key:index,attrs:{"questionInfo":question,"indent":0}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }